var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSimChevronLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Percorso",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 0,
    d: "M 26.822754 44.746094 C 26.822754 45.820313 27.262329 46.796875 28.043579 47.626953 L 58.21936 77.607422 C 58.95166 78.388672 59.977051 78.779297 61.10022 78.779297 C 63.395142 78.779297 65.104126 77.070313 65.104126 74.775391 C 65.104126 73.652344 64.664551 72.675781 63.932251 71.894531 L 36.686157 44.746094 L 63.932251 17.597656 C 64.664551 16.816406 65.104126 15.791016 65.104126 14.716797 C 65.104126 12.421875 63.395142 10.712891 61.10022 10.712891 C 59.977051 10.712891 58.95166 11.103516 58.21936 11.884766 L 28.043579 41.865234 C 27.262329 42.695313 26.822754 43.671875 26.822754 44.746094 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimChevronLeft);
export default __webpack_public_path__ + "static/media/sim-chevron-left.7871d60de2a86be802158844cb5f7230.svg";
export { ForwardRef as ReactComponent };